export default "__VITE_ASSET__5d1006f3__"